import { useApiQuery } from '@/api/hooks/useQuery';
import { profilePictureKeys } from '@/api/queryKeys';

/**
 * Hook to fetch the current member's profile picture.
 * This fetches the public profile which includes profileImageUrl.
 *
 * @param memberId - The member's ID (from useMemberInfo)
 * @returns Query result with profileImageUrl
 */
export function useMemberProfilePicture(memberId: number | undefined) {
  return useApiQuery({
    queryKey: profilePictureKeys.detail(memberId ?? 0),
    queryFn: (api) => async () => {
      const response = await api.members.membersControllerGetPublicMemberProfile(memberId!);
      return response.data;
    },
    enabled: !!memberId,
    gcTime: 5 * 60 * 1000, // Cache for 5 minutes
    staleTime: 60 * 1000, // Consider stale after 1 minute
  });
}
